import { render, staticRenderFns } from "./RecapStatic.vue?vue&type=template&id=09cbf18c&scoped=true"
import script from "./RecapStatic.vue?vue&type=script&lang=js"
export * from "./RecapStatic.vue?vue&type=script&lang=js"
import style0 from "./RecapStatic.vue?vue&type=style&index=0&id=09cbf18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cbf18c",
  null
  
)

export default component.exports